export { default } from 'features/Blog/BlogArticle'



// WEBPACK FOOTER //
// ./src/pages/BlogArticle/index.js